"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// reminder to not import AppUI to avoid circular dependencies
var AudioStream = /*#__PURE__*/function () {
  function AudioStream() {
    _classCallCheck(this, AudioStream);
  }
  return _createClass(AudioStream, [{
    key: "onStreamSuccess",
    value: function () {
      var _onStreamSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(stream, levelChangeCallback) {
        var audioContext, mediaStreamSource, processor, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.levelChangeCallback = levelChangeCallback;
              window.AudioContext = window.AudioContext || window.webkitAudioContext;
              audioContext = new AudioContext();
              mediaStreamSource = audioContext.createMediaStreamSource(stream);
              this.audioContext = audioContext;
              this.mediaStreamSource = mediaStreamSource;
              _context.p = 1;
              _context.n = 2;
              return this.createAudioProcessor(audioContext);
            case 2:
              processor = _context.v;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              if (this.audioContext === audioContext) {
                this.cleanup();
              }
              return _context.a(2);
            case 4:
              if (!(this.audioContext !== audioContext || this.mediaStreamSource !== mediaStreamSource || audioContext.state === 'closed')) {
                _context.n = 5;
                break;
              }
              if (processor) {
                processor.disconnect();
                processor.port.close();
              }
              return _context.a(2);
            case 5:
              this.processor = processor;
              if (processor) {
                mediaStreamSource.connect(processor);
              }
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function onStreamSuccess(_x, _x2) {
        return _onStreamSuccess.apply(this, arguments);
      }
      return onStreamSuccess;
    }()
  }, {
    key: "startMonitor",
    value: function startMonitor() {
      var _this = this;
      if (this.processor) {
        this.processor.port.onmessage = function (event) {
          if (_this.levelChangeCallback) {
            _this.levelChangeCallback(event.data.volume);
          }
        };
      }
    }
  }, {
    key: "stopMonitor",
    value: function stopMonitor() {
      if (this.processor) {
        this.processor.port.onmessage = null;
      }
    }
  }, {
    key: "createAudioProcessor",
    value: function () {
      var _createAudioProcessor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(audioContext) {
        var processor;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(audioContext.state === 'suspended')) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return audioContext.resume();
            case 1:
              if (!(audioContext.state !== 'running')) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return new Promise(function (resolve) {
                if (audioContext.state === 'running') {
                  resolve();
                } else {
                  var _onStateChange = function onStateChange() {
                    if (audioContext.state === 'running' || audioContext.state === 'closed') {
                      audioContext.removeEventListener('statechange', _onStateChange);
                      resolve();
                    }
                  };
                  audioContext.addEventListener('statechange', _onStateChange);
                }
              });
            case 2:
              if (!(audioContext.state === 'closed')) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, null);
            case 3:
              _context2.n = 4;
              return audioContext.audioWorklet.addModule('/volume-processor.js');
            case 4:
              if (!(audioContext.state === 'closed')) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2, null);
            case 5:
              processor = new AudioWorkletNode(audioContext, 'volume-processor');
              processor.connect(audioContext.destination);
              return _context2.a(2, processor);
          }
        }, _callee2);
      }));
      function createAudioProcessor(_x3) {
        return _createAudioProcessor.apply(this, arguments);
      }
      return createAudioProcessor;
    }()
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.stopMonitor();
      if (this.processor) {
        this.processor.disconnect();
        this.processor.port.close();
        this.processor = null;
      }
      if (this.mediaStreamSource) {
        this.mediaStreamSource.disconnect();
        this.mediaStreamSource = null;
      }
      if (this.audioContext) {
        if (this.audioContext.state !== 'closed') {
          this.audioContext.close();
        }
        this.audioContext = null;
      }
      this.levelChangeCallback = null;
    }
  }]);
}();
var _default = exports["default"] = AudioStream;